// This composable is for shared functionality in some shoutouts pages regarding emojis and points naming. Primarily,
// it handles the pluralization search caching of entered names, but there is shared copy as well
import { computed, inject, watch } from 'vue';
import { useStore } from 'vuex';
import useSearchCaching from 'composables/search-caching';

const useShoutoutsPointsAndEmojis = (pointsName) => {
  const $i18n = inject('$i18n');
  const { commit } = useStore();
  const { cacheValueAtFullPath, activelyTyping } = useSearchCaching({ query: pointsName, basePath: '/utils/pluralize' });

  const emojiDesc = `When someone sends a message with this emoji and a tagged teammate, Donut will count it as a ${$i18n.t('shoutouts.shoutout', { count: 1 })} and award points.`
      + '\n\nAt Donut we use :doughnut: — but you can choose one that best fits your culture.';

  const pointWords = computed(() => {
    const pointCache = cacheValueAtFullPath.value;
    if (pointCache?.status === 'complete') return { singular: pointCache.result.original, plural: pointCache.result.plural };
    return { singular: $i18n.t('shoutouts.point', { count: 1 }), plural: $i18n.t('shoutouts.point', { count: 2 }) };
  });

  watch(pointWords, (newValue) => {
    // Once we've calculated the new plural value for the point name, put it into state
    commit('pointsConfig/updateConfigKey', { key: 'points_name_plural', value: newValue.plural });
  });

  return { cacheValueAtFullPath, activelyTyping, emojiDesc, pointWords };
};

export default useShoutoutsPointsAndEmojis;
